
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's02c72eca8096d52b': `Frecuencia :`,
's061681af0ef72b5b': `Fuente : RCP`,
's07b491eb0576ebe7': `Frecuentes`,
's0a0128aa069c7079': `MEDICAMENTOS`,
's2275181e03237a7d': `Elija frecuencia.`,
's239412ba24c41c3d': `REACCIONES ADVERSAS`,
's4f98e3dc95342d4b': `DISPOSITIVO`,
's5bc631044823f152': `Desconocida`,
's66816dfbf0e7ecb1': `Poco frecuentes`,
's6c4f34936917c922': `Elija el nivel de visualización.`,
's6cac4d926f758862': `Muy raras`,
's7ac2ed2b6e85c444': `No existen reacciones adversas cuyas frecuencias sean :`,
's9834072bd350f59d': `Raras`,
's9cf567bc9eccb5b4': `Muy frecuentes`,
's9dfd349c32ba726b': `Restablecer el nivel de visualización.`,
'scd2231ae377afdd4': `Nivel de visualización actual.`,
'se7692ace93a23c21': `Excepcionales`,
'sf8cdcbf29ee05fbd': `Casos aislados`,
    };
  